// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from 'react-router'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import ErrorBoundary from 'church-theme-library/components/ErrorBoundary/ErrorBoundary'
import PageHeader from 'church-theme-library/pages/PageHeader'
import PageFooter from 'church-theme-library/pages/PageFooter'
import Page from 'church-theme-library/pages/Page'
// import ShareLinks from 'church-theme-library/components/Share/ShareLinks'
// import Comments from 'church-theme-library/components/Comments/Comments'
import PostTile from 'church-theme-library/components/PostTile/PostTile'

class MainLayout extends React.Component {
	handleWaypointEnter = () => {
		document.body.classList.remove( 'scroll-at-main-inner' )
	}

	handleWaypointLeave = () => {
		document.body.classList.add( 'scroll-at-main-inner' )
	}

	render() {
		const { translate, isLoading, hasSidebar, location, match, type, currentlyViewedPage } = this.props
		const isAppended = this.props.pageOverride ? true : false
		const page = isAppended ? this.props.pageOverride : this.props.page

		let showPrimaryContent = true

		return (
			<div className="main-item">
				<PageHeader { ...this.props } />

				<Waypoint
					onEnter={ this.handleWaypointEnter }
					onLeave={ this.handleWaypointLeave }
				/>

				<div className="main-inner">
					{ showPrimaryContent &&
						<div className="primary-wrap">
							<div className="primary-content">
								<ErrorBoundary>
									{ this.props.children }
								</ErrorBoundary>
							</div>
						</div>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		hasSidebar: state.site.hasSidebar,
		page: state.page.selected,
		currentlyViewedPage: state.page.currentlyViewedPage
	}
}

export default localize(
	withRouter(
		connect( mapStateToProps )( MainLayout )
	)
)
